import React, { useEffect, useRef, useState } from "react";
// import { appApiHandler } from "../../../../api/appApiHandler";
import "./SizeSlider.css";
import TitleHeader from "../TitleHeader";

const SCROLL_STEP = 250;

const SizeSlider = ({ onSizeClick, sizes = [] }) => {
  const trackRef = useRef(null);

  const [selectedSize, setSelectedSize] = useState("");

  // API CALL
  // const getFilterParams = async () => {
  //   try {
  //     const response = await appApiHandler.getProductFilterParams();

  //     if (response?.status === 200 && response?.sizes) {
  //       setSizes(response.sizes);

  //       // first size selected by default
  //       setSelectedSize(response.sizes[0]);
  //     }
  //   } catch (error) {
  //     console.log("API ERROR =>", error);
  //   }
  // };

  // useEffect(() => {
  //   // getFilterParams();
  // }, []);


   // --- AUTO SCROLL LOGIC ---
  useEffect(() => {
    const scroller = trackRef.current;
    if (!scroller || sizes.length === 0) return;
    const intervalId = setInterval(() => {
      
      if (scroller.scrollLeft + scroller.clientWidth >= scroller.scrollWidth - 10) {
        
        //if end so restart from start 
        scroller.scrollTo({ left: 0, behavior: "smooth" });
      } else {
      
        scroller.scrollBy({ left: SCROLL_STEP, behavior: "smooth" });
      }
    }, 3000); 
    return () => clearInterval(intervalId); 
  }, [sizes]);
  // -------------------------


  useEffect(() => {
  if (sizes?.length > 0) {
    setSelectedSize(sizes[0]);
  }
}, [sizes]);

  const scrollSizes = (direction) => {
    trackRef.current?.scrollBy({
      left: direction * SCROLL_STEP,
      behavior: "smooth",
    });
  };

  if (!sizes.length) return null;

  return (
    <section className="sizeWrapper">
      {/* TITLE */}
      <TitleHeader title="Blouses By Size" lineWidth={0.38} />

      <div className="sizeSlider__container">
        {/* SLIDER */}
        <div className="sizeSlider">
          {/* LEFT BUTTON */}
          <button className="sliderArrow left" onClick={() => scrollSizes(-1)}>
            ❮
          </button>

          {/* SIZE LIST */}
          <div className="sizeTrack" ref={trackRef}>
            {sizes.map((item, index) => {
              const isActive = selectedSize === item;

              return (
                <button
                  key={index}
                  className={`sizeCard ${isActive ? "activeSizeCard" : ""}`}
                  onClick={() => {
                    setSelectedSize(item);
                    onSizeClick(item);
                  }}
                >
                  <span className="sizeText">{item}</span>
                </button>
              );
            })}
          </div>

          {/* RIGHT BUTTON */}
          <button className="sliderArrow right" onClick={() => scrollSizes(1)}>
            ❯
          </button>
        </div>
      </div>
    </section>
  );
};

export default SizeSlider;